import React, { useEffect } from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../App.css";
import image from "../assests/Cyberthreats.png";
import AOS from "aos";
import "aos/dist/aos.css";
import NewsletterSection from "./NewsLetter";
import { Link } from "react-router-dom";
import HeroSection from "./HeroSection";

function Blog1() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="app">
      <Header />
      <Navbar />
      {/* <div className="bg-customBlue text-white py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div data-aos="fade-up" className="space-y-4 flex flex-col items-center text-center">
          <h1 className="font-nova-square text-4xl font-thin text-black">
          The Diring Need Of Protecting the Industry against Cyberthreats
          </h1>
          <p className="text-black">
          <Link to={"/"}> Home </Link>{' > '} <Link to={"/blog1"}>Blogs </Link> {'>'} <Link to={"/blog/blog1"}>The Diring Need Of Protecting... </Link>
          </p>
        </div>
      </div>
      </div> */}

      <HeroSection 
        title="The Diring Need Of Protecting the Industry against Cyberthreats" 
        breadcrumb={
          <>
            <Link to={"/blog1"}>Blog</Link> {' > '} 
            <Link to={"/blog1"}>The Diring Need Of Protecting the Industry against Cyberthreats</Link>
          </>
        } 
      />

      <div className="max-w-4xl mx-auto p-6 space-y-5 mt-8">
        {/* Header metadata */}
        {/* <div 
          data-aos="fade-up" 
          className="flex items-center gap-4 text-gray-600 mb-6"
        >
          <div className="flex items-center gap-2">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <span>Mack Jon</span>
          </div>
          <div className="flex items-center gap-2">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <span>20 Aug 2024</span>
          </div>
          <div className="flex items-center gap-2">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <span>Cyber Resilience</span>
          </div>
        </div> */}

        {/* Main heading */}
        {/* <h1 
          data-aos="fade-up" 
          data-aos-delay="100"
          className="text-4xl font-bold text-gray-700 mb-8"
        >
          The Diring Need Of Protecting the Industry against Cyberthreats
        </h1> */}

        {/* Main content */}
        <div className="space-y-6 text-gray-600">
          <div 
            data-aos="fade-up" 
            data-aos-delay="200"
            className="overflow-hidden"
          >
            <img
              src={image}
              alt="Mission Control Software"
              className="w-full h-[400px] object-cover transform transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          
          <p 
            data-aos="fade-up" 
            data-aos-delay="300"
            className="text-lg text-justify"
          >
            The increased connectivity, industrial facilities are now a favourite target for cybercriminals. Kristellar Aerospace provides a variety of tried-and-true solutions and services that combine top-notch cybersecurity expertise with in-depth knowledge of the aerospace, defence, IT, and space sectors to address this threat.
          </p>
          
          <hr className="border-gray-300 my-4" />
          
          <p 
            data-aos="fade-up"
            className="text-lg text-justify"
          >
            New threats are created every hour of every day in the computerised world of today. By connecting to the Internet, you increase the likelihood that a hacker may target your company. Cyber risk is a major concern for organisations and governments around the world as cybercrime grows in importance. Inadequate cybersecurity plans by organisations pose significant financial and brand concerns. The entire system is exposed if not all components are similarly safe, as cybercriminals are proficient at taking advantage of flaws in cyberspace.
          </p>

          {/* Testimonial section */}
          <div 
            data-aos="fade-up"
            className="bg-gray-200 p-8 rounded-lg mt-8"
          >
            <p className="text-lg text-gray-600 italic text-center mb-4 ">
              For instance, a serious security lapse occurred in Canada in 2011 when the computer systems of three important federal government ministries were compromised. Even while it was apparent that no personal information had been hacked, the hackers were nonetheless able to steal extremely sensitive data and take the departments offline for months. The Canadian Auditor General noted in 2012 that the government's response to the 2011 breach showed that systems were obviously vulnerable and that best practices for information security weren't always followed.
            </p>
          </div>
              
          <p 
            data-aos="fade-up"
            className="text-lg text-justify"
          >
            Many non-human entities, including as robots, microservices, automated processes, and technologies with system access, like IoT devices and operational technology, can also be used by criminals. In fact, there are numerous weak points in corporate IT systems, including out-of-date and unpatched software, missing or unsatisfactory encryption, unsafe SQL databases, data access points (like web-based applications), and website input fields that permit submission of JavaScript, ActiveX, and other code.
          </p>
          
          <hr className="border-gray-300 my-4" />
          
          <p 
            data-aos="fade-up"
            className="text-lg text-justify"
          >
            Purpose-driven access- Older techniques, including sending a "one-time password" to an email address via internet protocols, are insufficient now because they are too vulnerable to hacking. Access must be contextual and time-bound instead, meaning it must be "just enough" and "just in time" to produce the necessary business outcomes. In comparison to multiple password resets and unsecure email delivery, passwordless multi factor authentication (MFA) is both more secure and generally faster for users.
          </p>
        </div>
      </div>

      <NewsletterSection />

      <Footer />
    </div>
  );
}

export default Blog1;